export default "__VITE_ASSET__c478dfdc__"